





























import { Component } from '@niknevis/vue-modules'
import StepBar from '@/modules/shared/components/panel/StepBar.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import { Prop } from 'vue-property-decorator'
import FinalPayment from '@/modules/transaction/components/shared/payment/FinalPayment.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseCart from '@/modules/common/cart/components/panel/BaseCart.vue'
import CouponDiscountForm from '@/modules/common/cart/components/shared/CouponDiscountForm.vue'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import { ContentCampaignStepThreeResource } from '@/modules/content-campaign/models/content-campaign-resource.model'
import { Data } from '@/modules/shared/models/data'
import Vue from 'vue'
import { PanelContentCampaignRoute } from '@/modules/content-campaign/routes/panel-content-campaign.route'
import {
  PanelContentCampaignPaymentlinkUseCase
} from '@/modules/content-campaign/use-cases/panel/panel-content-campaign-paymentlink-use.case'
import { StartPaymentResource } from '@/modules/transaction/models/payment.model'
import { ContentCampaignPaymentLinkRequest } from '@/modules/content-campaign/models/content-campaign-request.model'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'کمپین تولید محتوا',
    page_sub_header: 'کمپین تولید محتوا خود را ثبت نهایی کنید.',
    over_header: StepBar,
    over_header_props: {
      stepNow: '2',
      steps: ['تنظیمات کمپین', 'پرداخت', 'پایان ثبت سفارش']
    }
  },
  metaInfo: {
    title: 'کمپین تولید محتوا'
  },
  components: {
    CouponDiscountForm,
    BaseCart,
    BaseButton,
    FinalPayment,
    Heading,
    StepBar
  }
})
export default class ContentCampaignStepThree extends Vue {
  constructor(
    private readonly routes: PanelContentCampaignRoute,
    private readonly useCase: PanelContentCampaignPaymentlinkUseCase
  ) {
    super()
  }

  @Prop() campaign!: Data<ContentCampaignStepThreeResource>

  loading = false

  get cart() {
    return this.campaign.data.cart
  }

  get payInfo() {
    return [
      {
        value: this.cart.items_count,
        unit: 'مقاله',
        column: 'تعداد مقاله'
      },
      {
        class: 'text-tes-red',
        value: this.cart.discount,
        unit: 'تومان',
        column: 'جمع تخفیف'
      },
      this.cart.tax ? {
        value: this.cart.tax,
        unit: 'تومان',
        column: 'مالیات'
      } : void 0,
      {
        value: this.cart.payable,
        unit: 'تومان',
        column: 'قابل پرداخت'
      }
    ].filter(Boolean)
  }

  async getPaymentResource(data: ContentCampaignPaymentLinkRequest): Promise<void | StartPaymentResource> {
    return this.useCase.execute(this.campaign.data.id, {
      ...data,
      coupon_code: this.cart.coupon?.code
    }).then(res => res)
  }

  get preInvoiceDownloadUrl() {
    let url = new URL(this.routes.invoice(this.campaign.data.id))
    if (this.cart.coupon) {
      url.searchParams.set('coupon_code', this.cart.coupon.code)
    }

    return url
  }

  get backUrl() {
    return this.routes.getStepOne(this.campaign.data.id)
  }

  get validateCouponUrl() {
    return this.routes.validateCoupon(this.campaign.data.id)
  }
}
